import {inlineError, tracer} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'
import {InitPaymentRequestTransactionsValueObject} from '../ValueObjects/InitPaymentRequestTransactionsValueObject.js'

/**
 * @implements UseCase
 */
class InitPaymentTransactionsUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new InitPaymentTransactionsUseCase({repository: HTTPTransactionRepository.create({config})})
  }

  @tracer({metric: 'InitPaymentTransactionsUseCase#execute'})
  @inlineError
  async execute({passcode, tradeId}) {
    const initPaymentRequest = InitPaymentRequestTransactionsValueObject.create({passcode, tradeId})

    const [error, response] = await this.#repository.initPayment(initPaymentRequest)

    if (error) throw error

    return response.toJSON()
  }
}

export default InitPaymentTransactionsUseCase.create
